import { 
  useEffect, 
  useState
} from "react";

import { 
  useDispatch, 
  useSelector 
} from "react-redux";

import { 
  Navbar,
  Nav,
  Container,
  Modal,
  Button
} from "react-bootstrap";

import 'bootstrap/dist/css/bootstrap.min.css';

import {
  setAuthorized,
  authSelector
} from "./store/authSlice";

import {
  openCompanyConf,
  openGeneralReg,
  openAppKey,
  hideLoading,
  confirmMsg,
  hideMsg,
  logoutComplete,
  pageSelector
} from "./store/pageSlice";

import { 
  VerifySession, 
  Logout 
} from "./api/auth";

import LoginPage from "./LoginPage";
import CompanyConfPage from "./CompanyConfPage";
import GeneralRegistryPage from "./GeneralRegistryPage";
import AppKeyPage from "./AppKeyPage";

import "./App.css";

export default function App() {
  const dispatch = useDispatch();

  const authSel = useSelector(authSelector);
  const pageSel = useSelector(pageSelector);

  const [showTrial, setShowTrial] = useState(false);

  // app start up
  useEffect(() => {
    document.title = "iFlexi License";

    (
      async () => {
        try {
          const result = await VerifySession();

          if (result) {
            dispatch(setAuthorized(true));
          }
        } catch (ex) {
          console.error(ex.message);
        } finally {
          dispatch(hideLoading());
        }
      }
    )();
  }, []);

  const submitLogout = async () => {
    try {
      await Logout();
    } catch (ex) {
      console.error(ex.message);
    } finally {
      dispatch(setAuthorized(false));
      dispatch(logoutComplete());
    }
  };

  const onNavSelect = (AEvtKey, AEvt) => {
    if (AEvtKey === "COMP_CONF") {
      setShowTrial(false);
      dispatch(openCompanyConf());
    } else if (AEvtKey === "GEN_REG") {
      dispatch(openGeneralReg());
    } else if (AEvtKey === "TRIAL_LICN") {
      setShowTrial(true);
      dispatch(openCompanyConf());
    } else if (AEvtKey === "APP_KEY") {
      dispatch(openAppKey());
    }
  };

  const onNav2Select = (AEvtKey, AEvt) => {
    if (AEvtKey === "LOGOUT") {
      (
        async () => { await submitLogout() }
      )();
    }
  };

  const closeMsg = () => { dispatch(hideMsg()) };

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg">
        <Container>
          <Navbar.Brand><img src="img/flexiteam_60_white.svg" className="brand-logo" /></Navbar.Brand>
          {
            authSel.isAuthorized && (
              <>
                <Navbar.Toggle />
                <Navbar.Collapse>
                  <Nav onSelect={onNavSelect} defaultActiveKey="COMP_CONF">
                    <Nav.Item>
                      <Nav.Link eventKey="COMP_CONF"><img className="button-icon" src="img/business_white_24dp.svg" />Companies</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="GEN_REG"><img className="button-icon" src="img/apps_white_24dp.svg" />Registry</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="TRIAL_LICN"><img className="button-icon" src="img/manage_history_white_24dp.svg" />Trial License</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="APP_KEY"><img className="button-icon" src="img/key_white_24dp.svg" />App. Key</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Navbar.Collapse>
                <Navbar.Collapse className="justify-content-end">
                  <Nav onSelect={onNav2Select} className="justify-content-end">
                    <Nav.Item>
                      <Nav.Link eventKey="LOGOUT"><img src="img/logout_white_24dp.svg" /></Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Navbar.Collapse>
              </>
            )
          }
        </Container>
      </Navbar>
      {
        !authSel.isAuthorized && (
          <LoginPage />
        )
      }
      {
        authSel.isAuthorized && pageSel.page === "COMP_CONF" && (
          <CompanyConfPage showTrial={ showTrial } />
        )
      }
      {
        authSel.isAuthorized && pageSel.page === "GEN_REG" && (
          <GeneralRegistryPage />
        )
      }
      {
        authSel.isAuthorized && pageSel.page === "APP_KEY" && (
          <AppKeyPage />
        )
      }
      {
        pageSel.showLoading && (
          <div className="loading-screen">
            <img src="img/loading.gif" />
            <img className="loading-flexi-logo" src="img/flexi-logo.png" />
          </div>
        )
      }
      <Modal show={ pageSel.showMsg} fullscreen="sm-down" onHide={ closeMsg } centered>
        <Modal.Header closeButton>
          <Modal.Title>{ pageSel.msgContent.title }</Modal.Title>
        </Modal.Header>
        <Modal.Body>{ pageSel.msgContent.message }</Modal.Body>
        {
          pageSel.msgId !== null && (
            <Modal.Footer>
              <Button variant="secondary" onClick={() => { dispatch(hideMsg()) }}>No</Button>
              <Button variant="primary" onClick={() => { dispatch(confirmMsg()) }}>Yes</Button>
            </Modal.Footer>
          )
        }
      </Modal>
    </>
  );
}
